var exports = {
  "kL": "x31de4314--456e30--container",
  "DD": "x31de4314--456e30--title",
  "x6": "x31de4314--456e30--button",
  "p_": "x31de4314--456e30--list",
};

module.exports = exports;
